module.exports = __webpack_public_path__ + "img/featuredartist15 (4).745fa22a.jpg";